(function () {
  // Prevent double init
  if (window.__REVAHS_UPG_INIT__) return;
  window.__REVAHS_UPG_INIT__ = true;

  var ROOT_SEL = '[data-revahs-upg]';
  var CFG_SEL = '[data-revahs-upg-config]';
  var DEFAULT_ATC_SEL = "[data-pf-type='ProductATC2']";

  function $(sel, scope) { return (scope || document).querySelector(sel); }
  function $all(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }

  var root = $(ROOT_SEL);
  if (!root) return;

  var cfgEl = $(CFG_SEL, root);
  if (!cfgEl) return;

  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent || '{}'); } catch (e) { cfg = {}; }

  var baseId = String(cfg.baseVariantId || '');
  var proId = String(cfg.proVariantId || '');
  if (!baseId || !proId) return;

  var baseHandle = String(cfg.baseHandle || '');
  var proHandle = String(cfg.proHandle || '');

  // ✅ Do NOT restrict to button; PF can render wrappers/anchors
  var atcSel = String(cfg.pageflyAtcSelector || DEFAULT_ATC_SEL);

  // locale/currency for formatting
  var locale = String(cfg.locale || 'nl-NL');
  var currency = String(cfg.currency || 'EUR');

  // Selected labels (optional, but we provide them in Liquid below)
  var labelBase = String(cfg.selectedModelBase || '');
  var labelPro = String(cfg.selectedModelPro || '');
  var suffixBase = String(cfg.selectedSuffixBase || '');
  var suffixPro = String(cfg.selectedSuffixPro || '');

  var cards = $all('[data-upg-card]', root);

  // Default selected (pro unless specified)
  var selected = root.getAttribute('data-default') === 'base' ? 'base' : 'pro';

  function getVariantId(key) {
    return key === 'base' ? baseId : proId;
  }

  function getSelectedKey() {
    var checked = root.querySelector('[data-upg-card][aria-checked="true"]');
    if (checked) return checked.getAttribute('data-key') || selected;
    return selected;
  }

  function formatMoneyFromCents(cents) {
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format((cents || 0) / 100);
    } catch (e) {
      // fallback
      return '€ ' + (((cents || 0) / 100).toFixed(2)).replace('.', ',');
    }
  }

  // --- Price sync ---
  var priceState = { base: null, pro: null }; // cents
  function setPriceUI(key, priceCents, compareCents) {
    var nowEl = root.querySelector('[data-upg-price="' + key + '"]');
    var wasEl = root.querySelector('[data-upg-compare="' + key + '"]');

    if (nowEl) nowEl.textContent = formatMoneyFromCents(priceCents);

    if (wasEl) {
      if (compareCents && compareCents > priceCents) {
        wasEl.hidden = false;
        wasEl.textContent = formatMoneyFromCents(compareCents);
      } else {
        wasEl.hidden = true;
      }
    }
  }

  function updateDelta() {
    var deltaWrap = root.querySelector('[data-upg-delta]');
    if (!deltaWrap) return;

    // Only show delta on PRO card if we have both prices
    if (typeof priceState.base !== 'number' || typeof priceState.pro !== 'number') {
      deltaWrap.hidden = true;
      return;
    }

    var diff = priceState.pro - priceState.base; // cents
    if (diff <= 0) {
      deltaWrap.hidden = true;
      return;
    }

    var tpl = deltaWrap.getAttribute('data-delta-tpl') || '__VALUE__';
    var txtEl = deltaWrap.querySelector('[data-upg-delta-text]');
    if (txtEl) txtEl.textContent = tpl.replace('__VALUE__', formatMoneyFromCents(diff));

    deltaWrap.hidden = false;
  }

  function fetchProduct(handle, cb) {
    if (!handle) return cb(null);
    var url = '/products/' + encodeURIComponent(handle) + '.js';

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { cb(data); })
      .catch(function () { cb(null); });
  }

  function loadPrices() {
    // Base
    fetchProduct(baseHandle, function (p) {
      if (!p || !p.variants) return;
      var v = p.variants.find(function (x) { return String(x.id) === baseId; });
      if (!v) return;

      priceState.base = Number(v.price);
      setPriceUI('base', Number(v.price), Number(v.compare_at_price || 0));
      updateDelta();
    });

    // Pro
    fetchProduct(proHandle, function (p) {
      if (!p || !p.variants) return;
      var v = p.variants.find(function (x) { return String(x.id) === proId; });
      if (!v) return;

      priceState.pro = Number(v.price);
      setPriceUI('pro', Number(v.price), Number(v.compare_at_price || 0));
      updateDelta();
    });
  }

  // --- PageFly / Form variant sync ---
  function syncVariantToATC() {
    var key = getSelectedKey();
    var variantId = String(getVariantId(key));

    var nodes = $all(atcSel);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];

      // ✅ Common PF + custom hooks
      el.setAttribute('data-variant-id', variantId);
      el.setAttribute('data-varient-id', variantId); // compatibility typo
      el.setAttribute('data-pf-variant-id', variantId);
      el.setAttribute('data-pf-product-variant-id', variantId);
      el.setAttribute('data-pf-variant', variantId);

      // ✅ Also update closest product form hidden input if present
      var form = el.closest && el.closest('form');
      if (!form && el.tagName && el.tagName.toLowerCase() === 'form') form = el;

      if (form) {
        var idInput = form.querySelector('input[name="id"]');
        if (idInput) idInput.value = variantId;
      }
    }
  }

  // --- Selected line text sync ---
  function syncSelectedLine() {
    var key = getSelectedKey();
    var modelEl = root.querySelector('[data-upg-selected-model]');
    var suffixEl = root.querySelector('[data-upg-selected-suffix]');

    if (modelEl) {
      if (key === 'base' && labelBase) modelEl.textContent = labelBase;
      if (key === 'pro' && labelPro) modelEl.textContent = labelPro;
    }
    if (suffixEl) {
      if (key === 'base' && suffixBase) suffixEl.textContent = suffixBase;
      if (key === 'pro' && suffixPro) suffixEl.textContent = suffixPro;
    }
  }

  function setSelected(key) {
    selected = (key === 'base') ? 'base' : 'pro';

    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      c.setAttribute('aria-checked', c.getAttribute('data-key') === selected ? 'true' : 'false');
    }

    syncVariantToATC();
    syncSelectedLine();
  }

  // --- Card interaction ---
  for (var i = 0; i < cards.length; i++) {
    (function (card) {
      card.addEventListener('click', function () {
        setSelected(card.getAttribute('data-key'));
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setSelected(card.getAttribute('data-key'));
        }
      });
    })(cards[i]);
  }

  // --- Modal ---
  var modal = root.querySelector('[data-revahs-upg-modal]');
  function openModal() { if (modal) { modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); } }
  function closeModal() { if (modal) { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); } }

  var openBtn = root.querySelector('[data-revahs-upg-open]');
  if (openBtn) openBtn.addEventListener('click', openModal);

  $all('[data-revahs-upg-close]', root).forEach(function (btn) {
    btn.addEventListener('click', closeModal);
  });

  $all('[data-revahs-upg-pick]', root).forEach(function (btn) {
    btn.addEventListener('click', function () {
      setSelected(btn.getAttribute('data-revahs-upg-pick'));
      closeModal();
    });
  });

  // --- Init ---
  setSelected(selected);
  loadPrices();

  // --- PageFly rebuild observer (throttled) ---
  var t = null;
  var obs = new MutationObserver(function () {
    if (t) return;
    t = setTimeout(function () {
      t = null;
      syncVariantToATC();
    }, 120);
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });

})();
